import { forwardRef } from 'react'
import _ReCAPTCHA from 'react-google-recaptcha'

import { RECAPTCHA_SITE_KEY } from 'shared/constants'

export const ReCAPTCHA = forwardRef(({ onChange }, ref) => (
  <_ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={onChange} ref={ref} />
))
